import { Paper, styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { useHttpClient } from "../../../../services/mortgage-client/MortgageClientContext";

const WarningContainer = styled(Paper)(({ theme }) => ({
    border: "1px solid #FFC107",
    borderLeft: "4px solid #FFC107",
    padding: "12px 54px 12px 44px",
    marginTop: "24px",
    position: "relative",
}));

const ConfigurationWarning = () => {
    const { t } = useTranslation();
    const httpClient = useHttpClient();

    return (
        <WarningContainer square={false} elevation={0} data-cy={"configuration-warning"}>
            <img
                style={{
                    position: "absolute",
                    top: 16,
                    left: 15,
                    width: 18,
                }}
                src={httpClient.buildUrl("icons/warning-icon.png")}
            />
            <Typography variant={"body1"}>
                {t(
                    "ConfigurationScreen.Please note that the redemption amount must be available in the displayed account at the due date. If you transfer the amount from an account that has withdrawal limits, you can avoid fees by cancelling on time."
                )}
            </Typography>
        </WarningContainer>
    );
};

export default ConfigurationWarning;
